import { render, staticRenderFns } from "./file-input-primary.vue?vue&type=template&id=3337aa47&scoped=true"
import script from "./file-input-primary.vue?vue&type=script&lang=js"
export * from "./file-input-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337aa47",
  null
  
)

export default component.exports